import { render, staticRenderFns } from "./AddReceiveForm.vue?vue&type=template&id=ad4c639e&"
import script from "./AddReceiveForm.vue?vue&type=script&lang=js&"
export * from "./AddReceiveForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports